/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

//import axios from '@/axios.js';
import firebase, { readSaleContext } from '@/services/saleData';
import { invalidateReport, currentReport } from '@/services/reportRange';
import 'firebase/database';
import 'firebase/storage';
//import router from '@/router';
import _ from 'lodash';
export default {
  // addItem({ commit }, item) {
  //   return new Promise((resolve, reject) => {
  //     axios.post("/api/data-list/products/", {item: item})
  //       .then((response) => {
  //         commit('ADD_ITEM', Object.assign(item, {id: response.data.id}))
  //         resolve(response)
  //       })
  //       .catch((error) => { reject(error) })
  //   })
  // },
  async fetchEmployee({commit}){
    const _users = (await firebase.database().ref(`/employee`).once('value')).val();
    const users = [];
    for(const x in _users){
      if(_users[x].email !== 'pong343@gmail.com' && _users[x].email !== 'pond@ufs896.com')
      users.push(_users[x]);
    }
    //console.log(users);
    commit('SET_EMPLOYEE',users);
  },
  resetUser({commit}){
    commit('RESET_USER');
  },
  saveData ({state}) {
    const user = _.clone(state.user)
    const emailKey = user.email.toString().replace(/\./g, '||')
    if(user.edit && user.password === '') {
      delete user.password
    }
    if(user.company === undefined) {
      user.company = '--TEST--'
    }
    return new Promise(async (resolve, reject) => {
      if(user.avatar_path.substring(0,5) === 'https'){
        user.avatar_path = null
        user.edit = null
        firebase.database().ref(`/users/${emailKey}`).set(user).then(()=> {
          resolve(`${user.firstname} ${user.lastname}`)
        }).catch((error) => { reject(error) })
        
      }else{
        user.avatar_path = null
        await firebase.storage().ref().child(`users/${user.email}`).put(user.avatar).then(() => {
          user.avatar = `https://firebasestorage.googleapis.com/v0/b/oktallentdb.appspot.com/o/users%2F${user.email}?alt=media`;
        });
        firebase.database().ref(`/users/${emailKey}`).set(user).then(()=> {
          resolve(`${user.firstname} ${user.lastname}`)
        }).catch((error) => { reject(error) })
      }
    })
  },
  async fetchSite ({ commit }) {
    const sites = (await firebase.database().ref(`/sites`).orderByChild('used').equalTo(true).once('value')).val();
    //const sites = (await firebase.database().ref(`/sites`).once('value')).val();
    commit('SET_SITES', sites);
  },
  fetchAddUsers ({commit,state},{user,key}) {
    let users = state.users;
    user.key = key;
    users.splice(0, 0, user);
    users = _.orderBy(users, ['createdate'],['desc']);
    const userIds = [];
    for(const x in users){
      userIds[users[x].code] = users[x].code;
    }
    for(const x in users){
      if(users[x].userFriendId){
        users[x].userFriendCode = userIds[users[x].userFriendId];
      }else{
        users[x].userFriendCode = '';
      }
    }
    commit('SET_USERS', users);
  },
  fetchUsersBank({ commit }) {
    firebase.database().ref().child('users').orderByChild('createdate').once('value', (snapshot) => {
      let users = []; 
      const userIds = [];
      snapshot.forEach((data) => {
        if(data.val().detail){
          const user = data.val();
          user.key = data.key;
          user.credit = (user.credit)?Number(user.credit).toFixed(2):0;
          users.push(user)
          userIds[user.code] = user.code;
        }
      });
      users = _.orderBy(users, ['createdate'],['desc']);
      for(const x in users){
        if(users[x].userFriendId){
          users[x].userFriendCode = userIds[users[x].userFriendId];
        }else{
          users[x].userFriendCode = '';
        }
      }
      commit('SET_USERSBANK', users);
    });
  },
  invalidateUsers ({state}) { invalidateMemberRequests(state); },
  invalidateHistory ({state}) { invalidateReport(memberRequest(state, 'history')); },
  invalidateLogs ({state}) { invalidateReport(memberRequest(state, 'logs')); },
  async fetchUsers ({commit, state}) {
    const owner = memberRequest(state, 'list');
    const generation = invalidateReport(owner);
    commit('SET_USERS', []);
    const {code} = await readSaleContext();
    const snapshot = await firebase.database().ref('users').orderByChild('userFriendId').equalTo(code).once('value');
    const users = [];
    snapshot.forEach(child => {
      const user = child.val();
      if (user.code === code) return;
      users.push({...user, key: child.key, credit: numberAmount(user.credit).toFixed(2), userFriendCode: user.userFriendId || ''});
    });
    if (!currentReport(owner, generation)) return {applied: false};
    commit('SET_USERS', _.orderBy(users, ['createdate'], ['desc']));
    return {applied: true};
  },
  async fetchUser ({commit, state}, userId) {
    const owner = memberRequest(state, 'detail');
    const generation = invalidateReport(owner);
    commit('SET_HISTORY', []); commit('SET_LOGS', []);
    const snapshot = await firebase.database().ref('users/' + userId).once('value');
    const profile = snapshot.val();
    if (!profile) throw new Error('ไม่พบข้อมูลลูกค้า');
    const user = {...profile, key: userId, webs: Object.keys(profile.web || {}).map(key => ({key, web: key.charAt(0).toUpperCase(), value: !!profile.web[key] && profile.web[key].status === true}))};
    const [spin, roulet, history, logs] = await Promise.all([
      memberRows('spin', [['code', '==', user.code]]),
      memberRows('roulet', [['code', '==', user.code]]),
      memberRows('history', [['code', '==', user.code], ['status', '==', 'ดำเนินการแล้ว']]),
      memberRows('historyCredit', [['code', '==', user.code], ['status', '==', true]])
    ]);
    if (!currentReport(owner, generation)) return {applied: false};
    const rows = history.concat(spin.map(row => ({...row, type: 'วงล้อ', qty: row.value})), roulet.map(row => ({...row, type: 'รูเล็ต', qty: row.value})));
    commit('SET_USER', user);
    commitHistory(commit, history, rows);
    commit('SET_LOGS', _.orderBy(logs, ['createdate'], ['desc']));
    return {applied: true};
  },
  async fetchHistory ({commit, state}, {userkey, startdate, enddate}) {
    const owner = memberRequest(state, 'history');
    const generation = invalidateReport(owner);
    commit('SET_HISTORY', []);
    const filters = [['userkey', '==', userkey], ['createdate', '>=', startdate + ' 00:00:00'], ['createdate', '<=', enddate + ' 23:59:59']];
    const [history, roulet, friends, waste, promotions] = await Promise.all([
      memberRows('history', filters.concat([['status', '==', 'ดำเนินการแล้ว']])),
      memberRows('roulet', filters), memberRows('sharefriend', filters), memberRows('waste', filters), memberRows('promotion', filters)
    ]);
    if (!currentReport(owner, generation)) return {applied: false};
    const rows = history.concat(
      roulet.map(row => ({...row, type: 'รูเล็ต', qty: row.value})),
      friends.map(row => ({...row, type: 'แนะนำเพื่อน 15%', qty: row.value})),
      waste.map(row => ({...row, type: 'คืนยอดเสีย', qty: row.waste})),
      promotions.map(row => ({...row, type: row.promotion, qty: row.credit}))
    );
    commitHistory(commit, history, rows);
    return {applied: true};
  },
  async fetchLogs ({commit, state}, {userId, startdate, enddate}) {
    const owner = memberRequest(state, 'logs');
    const generation = invalidateReport(owner);
    commit('SET_LOGS', []);
    const rows = await memberRows('historyCredit', [['code', '==', userId], ['createdate', '>=', startdate + ' 00:00:00'], ['createdate', '<=', enddate + ' 23:59:59'], ['status', '==', true]]);
    if (!currentReport(owner, generation) || state.user.code !== userId) return {applied: false};
    commit('SET_LOGS', _.orderBy(rows, ['createdate'], ['desc']));
    return {applied: true};
  },
  updateUsers({state,commit}, {key,value}){
    // console.log(key);
    // console.log(value);
    // console.log(state.users);
    const users = state.users;
    const keyUser = _.findKey(users, function(o) { return o.key === key; });
    if(keyUser){
      if(value.userFriendId){
        const keyUser2 = _.findKey(users, function(o) { return o.userId === value.userFriendId; });
        if(keyUser2 && users[keyUser2] && users[keyUser2].code){
          value.userFriendCode = users[keyUser2].code;
        }
      }else{
        value.userFriendCode = '';
      }
      users.splice(keyUser, 1);
      value.key = key;
      users.splice(keyUser, 0, value);
      commit('SET_USERS', users);
    }
  },
  /*fetchUser ({commit}, userId) {
    const data = localStorage.getItem('userInfo');
    const user = JSON.parse(data);
    return new Promise((resolve, reject) => {
      firebase.database().ref().child('users').orderByChild('company').equalTo(user.company).once('value', (snapshot) => {
        snapshot.forEach((arrData) => {
          if(arrData.val().code == userId){
            const user = arrData.val();
            if(user.avatar)
              user.avatar_path = user.avatar;
            user.edit = true;
            delete user.password;
            commit('SET_USER', user);
            resolve(user);
          } 
        });
      }).catch((error) => { reject(error) });
    })
    return new Promise((resolve, reject) => {
      axios.get(`/api/user-management/users/${userId}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },*/
  async updateFieldUsers({state},{key,value,column}) {
    if(key){
      if(column === 'account_no'){
        let checkbankno = '';
        if(value.toString().length == 10)
            checkbankno = value.toString().substring(3, value.toString().length);
        else
            checkbankno = value.toString().substring(5, value.toString().length);
        const scbcheck = value.toString().slice(-6);
        firebase.database().ref('users/'+key).update({
          account_no:value,
          account_no_check:checkbankno,
          account_no_check_scb:scbcheck,
        });
      }else if(column === 'status'){
        const users = state.users;
          const user = _.find(users, function(o) { return o.key === key; });
          if(value === 'Y'){
            const update = {};
            for(const x in user.web){
              update[x] = user.web[x];
              update[x].status = true;
            }
            firebase.database().ref('users/'+key).update({
              web:update,
              status:value
            });
          }else{
            const update = {};
            for(const x in user.web){
              update[x] = user.web[x];
              update[x].status = false;
            }
            firebase.database().ref('users/'+key).update({
              web:update,
              status:value
            });
          }
      }else if(column === 'ball'){
        if(value === 'Y'){
          firebase.database().ref('users/'+key).update({
            [`${column}`]:true,
          });
        }else{
          firebase.database().ref('users/'+key).update({
            [`${column}`]:null,
          });
        }
      }else{
        firebase.database().ref('users/'+key).update({
          [`${column}`]:value,
        });
      }
    }
  },
  getUsersOption({commit}){
    firebase.database().ref().child('users').orderByChild('status').equalTo('Y').once('value', (snapshot) => {
      const users = [];
      snapshot.forEach((arrData) => {
        users.push({
          code:arrData.val().code,
          key:arrData.key
        });
      });
      const _users = _.orderBy(users, ['code'],['asc']);
      commit('SET_USEROPTION', _users);
    })
  },
  getUsersOptionTureWallet({commit}){
    firebase.database().ref().child('users').orderByChild('bank').equalTo('truewallet').once('value', (snapshot) => {
      const users = [];
      snapshot.forEach((arrData) => {
        users.push({
          code:arrData.val().code,
          key:arrData.key
        });
      });
      const _users = _.orderBy(users, ['code'],['asc']);
      commit('SET_USEROPTION_TRUEWALLET', _users);
    })
  },
  fetchBanners ({ commit }){
    firebase.database().ref().child('banners').once('value', (snapshot) => {
      let banners = []; 
      snapshot.forEach((data) => {
        const user = data.val();
        user.key = data.key;
        banners.push(user)
      });
      banners = _.orderBy(banners, ['createdate'],['desc']);
      commit('SET_BANNERS', banners);
    });
  },
  removeRecord (userId) {
    return new Promise(() => {
      firebase.database().ref('users/'+userId).remove();
    })
  }
}

async function memberRows (collection, filters) {
  let query = firebase.firestore().collection(collection);
  for (const [field, op, value] of filters) query = query.where(field, op, value);
  const result = await query.get();
  return result.docs.map(doc => doc.data());
}
const memberRequests = new WeakMap();
function memberRequest (state, kind) {
  if (!memberRequests.has(state)) memberRequests.set(state, {});
  const owners = memberRequests.get(state);
  if (!owners[kind]) owners[kind] = {};
  return owners[kind];
}
function invalidateMemberRequests (state) {
  for (const owner of Object.values(memberRequests.get(state) || {})) invalidateReport(owner);
}
function numberAmount (value) {
  const number = Number(String(value == null ? '' : value).replace(/,/g, ''));
  return Number.isFinite(number) ? number : 0;
}
function commitHistory (commit, history, rows) {
  const deposit = history.reduce((total, row) => total + (row.type === 'ฝาก' ? numberAmount(row.qty) : 0), 0);
  const withdraw = history.reduce((total, row) => total + (row.type === 'ถอน' ? numberAmount(row.qty) : 0), 0);
  commit('SET_DEPOSIT_TOTAL', -deposit); commit('SET_WITHDRAW_TOTAL', withdraw);
  commit('SET_TOTAL', withdraw - deposit);
  commit('SET_TOTAL_BONUS', history.reduce((total, row) => total + numberAmount(row.bonus), 0));
  commit('SET_HISTORY', _.orderBy(rows, ['createdate'], ['desc']));
}
